{
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Back to main account",
      "backLinkedAccount": "Back to the linked account",
      "backMyAccount": "Back to My Account",
      "myAccount": "My account"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion is now available for your account",
      "desc": "Here are some of the Custom AI Companion features you can use in your account:",
      "studioTitle": "AI Studio",
      "studioDesc": "Customize the AI Companion experience for your organization.",
      "integrationsTitle": "Third-party integrations",
      "integrationsDesc": "Leverage third-party apps to streamline your workflows.",
      "clipsTitle": "Custom avatars for Zoom Clips",
      "clipsDesc": "Allow users to personalize AI avatars to use in their clips."
    },
    "coachMark": {
      "licenseTitle": "You have {0} Custom AI Companion licenses to assign",
      "licenseDesc": "Assign these licenses under <b>User Management</b> so your users can start using advanced AI Companion capabilities.",
      "settingTitle": "Check out Custom AI Companion settings for your account",
      "settingDesc": "Configure settings for each Custom AI feature under <b>Account Settings</b>. <a href=\"/account/setting?tab=aicompanion\">Go to settings</a>",
      "groupSettingTitle": "Check out Custom AI settings for your group",
      "groupSettingDesc": "Configure settings for each Custom AI feature under <b>Group Settings</b>. <a href=\"/account/group\">Go to settings</a>"
    },
    "common": {
      "learnMore": "Learn more",
      "quickTour": "Take a quick tour",
      "remindLater": "Remind me later",
      "dismiss": "Dismiss",
      "next": "Next",
      "back": "Back",
      "gotIt": "Got it",
      "goToSetting": "Go to setting"
    },
    "aiPanelToast": "Turn on the <b>AI panel in Zoom Workplace</b> setting to start using all of the Custom AI Companion features."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Got it",
      "next": "Next",
      "remindMeLater": "Remind me later",
      "waffleMenuTitle": "Welcome to the new Zoom web experience",
      "waffleMenuDesc": "Access Zoom products from wherever you are with our new <b>product menu.</b>",
      "profileMenuTitle": "My account",
      "profileMenuDesc": "Find your profile and personal settings in <b>My account.</b>",
      "personalTitle": "Access everything you need",
      "personalDesc": "<b>My account</b> includes your profile, settings, meeting transcripts, and more.",
      "adminCenterTitle": "Find organization settings in Admin Center",
      "adminCenterDesc": "Your new <b>Admin center</b> lets you configure products and adjust settings for your entire organization.",
      "adminMenuForTitle": "Use Admin center like a pro",
      "adminMenuForAccountSettings": "<b>Settings</b> lets you access default product settings for everyone in your organization.",
      "adminMenuForContentManagementItem": "<b>Content management</b> is where you can manage all user-generated content.",
      "adminMenuForConfigureProductsItem": "<b>Product configuration</b> lets you set up and complete admin tasks for your products.",
      "adminMenuForNoItems": "The new admin center lets you access and manage your account settings and products more easily. You can also pin any items you want for quicker access.",
      "tryNewExperience": "Try new experience",
      "tryNewExperienceDetail": "Give it a try! You can always return to this, the classic experience.",
      "tryNewExperienceTitle": "New look and feel for Zoom Web!"
    }
  },
  "commonHeader": {
    "upgradeToPro": "Upgrade",
    "learnMore": "Learn More",
    "aicForAdmin": {
      "coachMark": {
        "title": "Manage your organization's account with AI",
        "description": "Get intelligent answers to your account questions and help navigating settings.",
        "terms": "By using Zoom's beta features, you agree to {0}",
        "termsText": "Zoom's Beta Program Terms"
      },
      "diveDeeper": "Dive deeper",
      "shareFeedback": "Share feedback in {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Ask about your organization's account",
      "heroInvite": "How do I invite a new user to my account?",
      "heroGroups": "How do I assign users to groups?",
      "heroRoles": "Tell me how to manage roles and permissions"
    },
    "backMainAccount": "Back to main account",
    "AIProductivitySuite": {
      "title": "AI Productivity Suite",
      "desc": "Turn inspired discussions into impressive deliverables."
    },
    "discoverProducts": "Discover Products",
    "pricing": "Pricing",
    "more": "More",
    "sidebarExpanded": "expanded",
    "sidebarCollapsed": "collapsed",
    "search": "Search",
    "users": "Users",
    "settings": "Account settings",
    "navigation": "Navigation",
    "clear": "Clear",
    "searchPlaceholderAll": "Search for users, account settings, or navigation",
    "searchPlaceholderUsers": "Search for users, or navigation",
    "searchPlaceholderSettings": "Search for account settings, or navigation",
    "searchPlaceholderNav": "Search for navigation",
    "searchGuide": "Type keywords to start your search",
    "searchEmpty": "No matching result",
    "noUsers": "Try another search. Or go to <a href=\"/account/user\">Users</a> page.",
    "noSettings": "Try another search. Or go to <a href=\"/account/setting\">Account settings</a> page.",
    "noNavigation": "Try another search.",
    "installOnDesktop": "Install on desktop",
    "downloadCenter": "Download center",
    "getInTouch": "Get in touch",
    "featuredProduct": "featured product",
    "logo": {
      "adminCenter": "Admin center",
      "subAccount": "Managing sub account",
      "externalAccount": "Managing delegated account"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisions are now available",
      "dvsTipsContent": "Divisions are used to create multiple instances of certain Zoom products within your account."
    },
    "common": {
      "learnMore": "Learn more",
      "gotIt": "Got it"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Manage external accounts",
      "extAccountTipsContent": "Need to manage another account? Just send a request—once they approve, you’re in!"
    },
    "common": {
      "learnMore": "Learn more",
      "gotIt": "Got it"
    }
  },
  "feedback": {
    "dialogTitle": "Give Feedback",
    "itemLableForProductArea": "Product Area",
    "itemLableForSatisfied": "How satisfied are you with your experience?",
    "dissatisfied": "Very Dissatisfied",
    "satisfied": "Very Satisfied",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Thank you for your ideas, comments, and suggestions.",
    "btnCancel": "Cancel",
    "btnSubmit": "Submit",
    "supportTips": "For technical support, please visit",
    "btnSupport": "Support.",
    "messages": {
      "success": "Thanks for your feedback!",
      "productFailed": "Product Area is required.",
      "scoreFailed": "Satisfaction score is required."
    },
    "products": {
      "General": "General",
      "AI": "AI",
      "Apps": "Apps",
      "Calendar": "Calendar",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Meetings",
      "Notes": "Notes",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Scheduler",
      "Tasks": "Tasks",
      "TeamChat": "Team Chat",
      "WebinarsAndEvents": "Webinars and Events",
      "Whiteboard": "Whiteboard",
      "WorkflowAutomations": "Workflow Automations",
      "WorkspaceReservation": "Workspace Reservation",
      "Workvivo": "Workvivo"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. All rights reserved.",
    "terms": "Terms",
    "privacy": "Privacy",
    "trust_center": "Trust Center",
    "acceptable_use_guidelines": "Acceptable Use Guidelines",
    "legal": "Legal",
    "do_not_sell_my_personal_information": "Your Privacy Choices",
    "cookie_preferences": "Cookie Preferences",
    "pricing": "Plans & Pricing",
    "feedback": "Feedback",
    "contact_us": "Contact Us"
  },
  "loginDisclaimer": {
    "disclaimer": "This disclaimer was generated by your account admin.",
    "cancel": "Cancel",
    "agree": "Agree"
  },
  "shared": {
    "sideMenu": {
      "personal": "Personal",
      "admin": "Admin",
      "menu": "Menu",
      "pinned": "Pinned",
      "pin": "Pin",
      "unpin": "Unpin",
      "moveItem": "Move item",
      "myAccount": "My account",
      "upgradeToPro": "Upgrade to Pro",
      "grabbedKeyboard": "{0} grabbed. Use up and down arrow keys to move, press space or enter to drop.",
      "dropped": "{0} dropped.",
      "releasedUnchanged": "{0} released, position unchanged.",
      "movedToPosition": "{0} moved to position {1} of {2}.",
      "movedUp": "{0} moved up, position {1} of {2}.",
      "movedDown": "{0} moved down, position {1} of {2}.",
      "movedUpNew": "{0} moved up, new position {1} of {2}",
      "movedDownNew": "{0} moved down, new position {1} of {2}",
      "cannotMoveFurther": "{0} cannot move further.",
      "grabbedMouse": "{0} grabbed. Move the mouse to reposition, click to drop, press Escape to cancel."
    },
    "item": "Item",
    "gotIt": "Got it",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Phone number added successfully! You can now use it for future sign-ins and account recovery.",
    "mfa_to_signin_phone_success": "{phone} is now the sign-in number for {email}.",
    "login_passkey_bound_success": "Passkey successfully created"
  },
  "termChange": {
    "changeTerm": {
      "title": "Renewal Term Change Agreement",
      "quoteNumbers": "Modified Order Form(s) - {0}",
      "content1": "By accepting these terms, Customer agrees to modify its existing subscription renewal term for all Order Forms between Zoom Communications, Inc. (“Zoom”) and Customer by changing the committed term from a month-to-month renewal term to a {0}. In exchange for this commitment, Zoom agrees to maintain Customer’s current pricing for the duration of the first new renewal term.",
      "content2": "Customer  understands that the new renewal term of {0} applies once Customer clicks “I Accept” below, and that the new renewal term will commence the day following the end of Customer’s current month-to-month renewal term. This new renewal term will apply to all Order Forms currently in effect with Zoom, and all future renewal terms under these Order Forms will have the same renewal term length.",
      "content3": "Customer acknowledges that the only change being made is to the renewal term, and that all other terms and conditions of each Order Form currently in effect with Zoom remain unchanged and in full force and effect in accordance with their terms.",
      "content4": "You further agree that this is a contractual commitment between Customer and Zoom.",
      "agreementText": "By clicking \"I accept,\" you certify that you are authorized to make this change on behalf of the Customer, and that Customer agrees to the terms and conditions detailed above.",
      "IDecline": "I decline",
      "IAccept": "I accept"
    },
    "unableToChangeTerm": {
      "title": "Unable to change renewal term",
      "content": "Your account is not eligible to update the renewal term. <a target=\"_blank\" href=\"{0}\">Contact us</a> if this is an error.",
      "acceptedTitle": "Renewal Term Extended",
      "acceptedContent": "You’ve previously accepted the renewal terms. No further action is needed.",
      "GotIt": "Got it"
    },
    "termLengthUpdated": "Renewal Term length updated to {0} months.",
    "termLengthUnchanged": "Term length unchanged.",
    "errorInfo": "A server error occurred. Try again.",
    "x12MonthTerm": "twelve (12) month term",
    "x24MonthTerm": "twenty-four (24) month term",
    "x12MonthTermPlural": "twelve (12) months",
    "x24MonthTermPlural": "twenty-four (24) months"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "The following advanced management features will only apply to licensed and collaboration users",
      "licensed_basic": "The following advanced management features will only apply to licensed and basic users",
      "licensed": "The following advanced management features will only apply to licensed users"
    },
    "support": "- Supported in account settings and user group settings",
    "archive_product": {
      "title": "Archive meetings and webinars",
      "detail": "- Meetings will be archived when users in your account join. To use this setting, install an <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">archiving app</a> from the Zoom App Marketplace."
    },
    "restrict": {
      "title": "Restrict users from using selected features when they join a meeting",
      "detail": "- Selected features cannot be used even if meeting hosts enable them for meetings."
    },
    "meeting_integration": {
      "title": "Enable in-meeting chat DLP (Data Loss Prevention) integration",
      "detail": "- When turned on, DLP will apply to both public and private chat messages that a participant sends. The messages will be immediately deleted if participants in a meeting (internal/external) are chatting and a message goes against the host organization's compliance policies."
    },
    "chat_tool": {
      "title": "Chat etiquette tool",
      "detail": "- Identify defined keywords and text patterns in shared content, and prevent users from sharing unwanted messages"
    },
    "information_barriers": {
      "title": "Information barriers",
      "detail": "- Information barriers control communications between certain users for compliance purposes. Restrictions on meetings and chat can be placed between users in two groups and on certain users from using specific features (i.e. in-meeting chat, screen share, and file transfer). These restrictions prevent confidential information from being exchanged between unauthorized users."
    },
    "dashboard": {
      "title": "Dashboard",
      "detail": "- For the meetings > past meetings dashboard, data displays for only 3 months for some users"
    },
    "reports": {
      "title": "Reports",
      "detail": "- Some user reports display data for only 3 months for some users: disclaimer report, attendee log report, admin activity logs report, and sign in/sign out report"
    },
    "close": "Close"
  },
  "webinarBar": {
    "body": {
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Your {planName} license will be paused on {pausedDate} for {pauseDuration}. To continue hosting webinars, assign an active license to this user before the pause takes effect. You can also remove the pause to keep using this license.",
            "nonAdmin": "Your {planName} license will be paused on {pausedDate} for {pauseDuration}. During in the pause period, you can only view the existing webinars and their assets. To continue hosting webinars, please contact your account admin to assign an active license to your account before the pause takes effect."
          },
          "active": {
            "admin": "Your {planName} license is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view the existing webinars. Feel free to resume the subscription of the license or assign an active license to your account to continue host webinars.",
            "nonAdmin": "Your {planName} license is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view the existing webinars. To host webinars during the pause, please contact your account admin to assign an active license to your account."
          }
        },
        "cancel": {
          "active": {
            "admin": "Your {planName} license will be canceled on {cancelDate}. To continue hosting webinars, please reactivate your webinar license or assign an active license before the cancellation takes effect. If no action is taken, you will have a grace period from {supportStartDate} - {supportEndDate} to contact Customer Support to retrieve your existing webinar data. After {dataLossDate}, all webinar data associated with your account will be permanently deleted.",
            "nonAdmin": "Your {planName} license will be canceled on {cancelDate}. To continue hosting webinars, please contact your account admin to reactivate your webinar license or assign an active license before the cancellation takes effect. If no action is taken, you will have a grace period from {supportStartDate} - {supportEndDate} to contact Customer Support to retrieve your existing webinar data. After {dataLossDate}, all webinar data associated with your account will be permanently deleted."
          },
          "expired": {
            "admin": "Your {planName} license has been canceled. To continue hosting webinars, assign an active license to this user. From {supportStartDate} - {supportEndDate}, you can contact Customer Support to retrieve existing webinar data.",
            "nonAdmin": "Your {planName} license has been canceled. To continue hosting webinars, please contact your account admin to assign an active license to your profile. From {supportStartDate} - {supportEndDate}, contact Customer Support to retrieve existing webinar data."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Your {planName} license will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view prior webinars' {supportContent}. To continue access webinars' assets, assign an active license to this user before the pause takes effect. You can also remove the pause to keep using this license.",
              "nonAdmin": "Your {planName} license will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view prior webinars' {supportContent}. To continue access webinars' assets, please contact your account admin to assign an active license to your profile."
            },
            "active": {
              "admin": "Your {planName} is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view existing webinars' {supportContent}. To continue access webinars' assets, please assign an active license to your account. You can also resume this license subscription any time.",
              "nonAdmin": "Your {planName} is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view existing webinars' {supportContent}. To host webinars during the pause, please contact your account admin to assign an active license to your account."
            }
          },
          "cancel": {
            "active": {
              "admin": "Your {planName} will be canceled on {cancelDate}. To continue hosting webinars, please assign an active license to your account before the cancellation takes effect. You can reactivate this license before {cancelDate}. From {supportStartDate} - {supportEndDate}, you can contact Customer Support to retrieve existing webinars' {supportContent}.",
              "nonAdmin": "Your {planName} license will be canceled on {cancelDate}. To continue hosting webinars, please contact your account admin to reactivate your webinar license or assign an active license before the cancellation takes effect. If no action is taken, you will have a grace period from {supportStartDate} - {supportEndDate} to contact Customer Support to retrieve your existing webinars' {supportContent}. After {dataLossDate}, all webinar data associated with your account will be permanently deleted."
            },
            "expired": {
              "admin": "Your {planName} license has been canceled. To continue hosting webinars, assign an active license to this user. From {supportStartDate} to {supportEndDate}, contact Customer Support to retrieve existing webinars' {supportContent}.",
              "nonAdmin": "Your {planName} license has been canceled. To continue hosting webinars, please contact your account admin to assign an active license to your profile. From {supportStartDate} to {supportEndDate}, contact Customer Support to retrieve existing webinars' {supportContent}."
            }
          }
        }
      },
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Your {planName} will be canceled on {cancelDate}. Before that date, you can reactivate your webinar licenses. From {supportStartDate} - {supportEndDate}, you can contact Customer Support to get existing webinar data. After {dataLossDate}, you will lose all webinar data.",
            "nonAdmin": "Your {planName} will be canceled on {cancelDate}. By that date, you can contact your account admin to reactivate your webinar licenses. From {supportStartDate} - {supportEndDate}, you can contact Customer Support to get existing webinar data. After {dataLossDate}, you will lose all your account's webinar data."
          },
          "admin": "Your {planName} will be canceled on {cancelDate}. By that date, you can reactivate your webinar licenses. From {supportStartDate} - {supportEndDate}, you can contact customer support to get existing webinars' {supportContent}. After {dataLossDate}, you will lose all your account's webinar data.",
          "nonAdmin": "Your {planName} will be canceled on {cancelDate}. By that date, you can contact your account admin to reactivate your webinar licenses. From {supportStartDate} - {supportEndDate}, you can contact customer support to get existing webinars' {supportContent}. After {dataLossDate}, you will lose all your account's webinar data."
        },
        "expired": {
          "admin": "Your {planName} is canceled. From {supportStartDate} - {supportEndDate}, you can contact customer support to get existing webinars' {supportContent}, or purchase Zoom Webinars again to restore data access. After {dataLossDate}, you will lose all your account's webinar data.",
          "nonAdmin": "Your {planName} is canceled. From {supportStartDate} - {supportEndDate}, you can contact customer support to get existing webinars' {supportContent}, or contact the account admin to purchase Zoom Webinars again to restore data access. After {dataLossDate}, you will lose all your account's webinar data."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Your {planName} will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view the existing webinars and their assets. Feel free to remove your pause and resume your webinar license subscription at any time.",
            "nonAdmin": "Your {planName} will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view the existing webinars and their assets. You can contact your account admin to remove your pause and resume your webinar license subscription at any time."
          },
          "admin": "Your {planName} will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view {supportContent}. Feel free to remove your pause and resume your webinar license subscription at any time.",
          "nonAdmin": "Your {planName} will be paused on {pausedDate} for {pauseDuration}. During the pause period, you can only view {supportContent}. You can contact your account admin to remove your pause and resume your webinar license subscription at any time."
        },
        "active": {
          "webinars": {
            "admin": "Your {planName} is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view the existing webinars. Feel free to resume your webinar license subscription at any time.",
            "nonAdmin": "Your {planName} is paused for {pauseDuration} starting from {pausedDate}. During the pause, you can only view the existing webinars. Feel free to contact your account admin to resume your webinar license subscription at any time."
          },
          "admin": "Your {planName} is paused for {pauseDuration}. During the pause, you can only view the existing webinars' {supportContent}. Feel free to resume your webinar license subscription at any time.",
          "nonAdmin": "Your {planName} is paused for {pauseDuration}. During the pause, you can only view the existing webinars' {supportContent}. Feel free to contact your account admin to resume your webinar license subscription at any time."
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "data",
        "recordingsAndTranscripts": "recordings and transcripts",
        "reports": "reports",
        "summaries": "summaries",
        "dashboard": "dashboards"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "prior webinars' recordings and transcripts",
          "reports": "prior webinars' reports",
          "summaries": "prior webinars' summaries",
          "dashboard": "prior webinars' dashboards",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Reactivate plan",
    "purchasePlan": "Purchase plan",
    "removePause": "Remove pause",
    "resumeSubscription": "Resume subscription",
    "assignLicense": "Assign License",
    "month": "month",
    "months": "months"
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Address Book will become Customer Directory",
      "tipsContent": "In the October 2026 release, we're renaming Address Book to Customer Directory to better reflect its purpose. All existing functionality, permissions, and workflows will remain the same—you'll continue managing customer lists (address books) and contacts just as you do today."
    },
    "common": {
      "gotIt": "Got it"
    }
  },
  "zoomPrivacy": {
    "agreeMain": "We're updating our terms and policies",
    "agreeSub": "By continuing to use Zoom, you accept the updated <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Terms of Service</a> and <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Privacy Policy</a>.",
    "continue": "Continue"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Your account is scheduled to update to the <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\"> new Zoom web experience</a> on {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Review when to update</a>"
    },
    "completed": {
      "content": "The new Zoom Web Experience is now active for all users on your account. Users will see the updated interface on their next login."
    }
  }
}
